import React from "react";
import { Steps, Space } from "antd";

const Stages = (props) => {
  const { onChangeStatus, items, value, direction } = props;
  const onChange = (value) => {
    onChangeStatus(value);
  };
  return (
    <div className="component" style={{ padding: "14px" }}>
      <Space
        direction="vertical"
        size="middle"
        style={{
          display: "flex",
        }}
      >
        <Steps
          current={value}
          onChange={onChange}
          size="small"
          className="site-navigation-steps"
          items={items}
          direction={direction}
        />
      </Space>
    </div>
  );
};
export default Stages;
